import type { SimpleFieldConfig } from "@/components/shared/UniversalCRMTable/types";

export const identityFields = {
  title: {
    type: "text",
    label: "Title",
    sortable: true,
    filterable: true,
    searchable: true,
    resizable: true,
    hideable: false,
    editable: true,
    formSpan: 3,
    filterType: "contains",
    width: 280,
    minWidth: 200,
    maxWidth: 400,
    required: true,
    validation: { required: "Title is required." },
    placeholder: "Enter offering title",
    icon: "Package",
    // Role-based access control - visible to all roles except client_user
    allowedRoles: ["wtc_admin", "wtc_crm"],
    // Show row actions inline with this column
    showRowActions: true,
    showOnCard: true,
    cardSpan: 2,
    mobileDetailSectionId: "identity",
  },
  linked_project_slug: {
    type: "text",
    label: "Linked Project",
    sortable: true,
    filterable: true,
    searchable: true,
    resizable: true,
    hideable: true,
    editable: true,
    formSpan: 2,
    filterType: "contains",
    width: 180,
    minWidth: 120,
    maxWidth: 250,
    placeholder: "cloud-migration, generative-ai-implementation",
    icon: "FolderOpen",
    allowedRoles: ["wtc_admin", "wtc_crm"],
    showOnCard: true,
    cardSpan: 3,
    mobileDetailSectionId: "identity",
  },
  tags: {
    type: "tags",
    label: "Tags",
    sortable: false,
    filterable: true,
    searchable: true,
    resizable: true,
    hideable: true,
    editable: true,
    formSpan: 3,
    width: 200,
    minWidth: 150,
    maxWidth: 300,
    placeholder: "Problem areas solved (e.g. compliance, automation)",
    icon: "Tag",
    allowedRoles: ["wtc_admin", "wtc_crm"],
    showOnCard: true,
    cardSpan: 3,
    mobileDetailSectionId: "identity",
  },
} satisfies Record<string, SimpleFieldConfig>;
